<section>
  <article class="container">
    <div class="row">
      <div class="col-12">
        <div class="tab-content" id="pills-tabContent">
          <!-- Expedientes -->
          <div
            class="tab-pane fade show active"
            id="pills-home"
            role="tabpanel"
            aria-labelledby="pills-home-tab"
          >
            <div class="container">
              <div class="row mt-5">
                <div
                  *ngFor="let item of archivos_list"
                  class="col-12 col-md-4 offset-0 mt-2"
                >
                  <div class="row d-flex align-items-center hoverable-item">
                    <div class="col-4">
                      <img
                        class="w-100"
                        src="./assets/imgs/img_file.jpg"
                        alt="Próximos viajes"
                      />
                    </div>
                    <div class="col-8">
                      <div class="w-100">
                        <h5>{{ item.nombre_mostrar }}</h5>
                      </div>

                      <small
                        >Fecha de carga:
                        {{ item.fecha | date: "dd/MM/yyyy" }}
                      </small>
                      <div class="w-100">
                        <a
                          href="{{ url_file(item.id, item.nombre) }}"
                          target="_blank"
                          download="{{ item.nombre_mostrar }}.{{ item.tipo }}"
                          >Descargar</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </article>
</section>
